// DatasetsTable.jsx
// Small read-only table used inside experiment pages to show mounted
// datasets. Expects `datasets` as an array of [name, mountPath].
//
// The component is intentionally lightweight and stateless — it only
// renders the provided list or a short empty state message when there
// are no datasets.
import PropTypes from "prop-types";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { FONT, INK_MUTED, HAIRLINE } from "../../../../theme/tokens";

export default function DatasetsTable({ datasets = [] }) {
  if (!datasets.length) {
    return (
      <Typography sx={{ fontSize: FONT.sm, color: INK_MUTED }}>
        No datasets mounted.
      </Typography>
    );
  }

  return (
    <TableContainer
      sx={{
        m: 0,
        boxShadow: "none",
        border: `1px solid ${HAIRLINE}`,
        borderRadius: 2,
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Dataset Name</TableCell>
            <TableCell>Mount Path</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {datasets.map(([name, path]) => (
            <TableRow key={name}>
              <TableCell>{name}</TableCell>
              <TableCell sx={{ fontFamily: "monospace", fontSize: FONT.xs }}>
                {path}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

DatasetsTable.propTypes = {
  datasets: PropTypes.arrayOf(PropTypes.array),
};
